import type { FileParameter } from "./ApiClient";

class FileService {
  async uploadFile(file: File): Promise<String> {
    try {
      const fileParam: FileParameter = {
        data: file,
        fileName: file.name,
      };
      const apiClient = useApiClient();
      const response = await apiClient.uploadFile(fileParam);
      if (!response.success) {
        throw new Error(`Upload failed: ${response.message}`);
      }
      return response.message ?? "";
    } catch (error) {
      console.error("File upload error:", error);
      throw error;
    }
  }

  getFileFullPath(filePath: string): string {
    const config = useRuntimeConfig();
    if (filePath?.startsWith("http")) {
      return filePath;
    } else {
      return (
        config.public.apiBaseUrl +
        "/api/v1/file-upload/display?filePath=" +
        filePath
      );
    }
  }
}

export default FileService;
